<div class="layout-content">
	<div *ngIf="fwUpdateStart">
		<div class="flex align-items-center justify-content-center w-full pb-8 mb-8">
			<p-progressSpinner ariaLabel="loading"></p-progressSpinner>
		</div>
	</div>
	<div *ngIf="!fwUpdateStart" class="px-2 py-3">
		<ng-container *ngIf="!showGroupedUpdates">
			<div class="grid align-items-center py-2" *ngFor="let firmware of mtmaFirmwareUpdates">
				<div [class]="!onExtendedMobile() ? 'col-8' : 'col-12 flex justify-content-center text-center'">
					<span>{{'MODULE_UPDATE' | translate }}: {{firmware.Description}} - {{'FROM_VERSION' | translate }}:
						{{firmware.DeviceFWVersion}} ---- {{'TO_VERSION' | translate }}: {{firmware.AvailableFWVersion}}</span>
				</div>
				<div [class]="!onExtendedMobile() ? 'col-4 flex justify-content-end' : 'col-12 flex justify-content-center'">
					<p-button label="{{ 'UPDATE_FIRWARE_MTMA' | translate }}" (click)="firmwareUpdate(firmware.Description)"
						[disabled]="isDeviceUnavailable() || onFirmwareUpdate()" icon="pi cm-update-firmware" severity="primary">
					</p-button>
				</div>
			</div>
		</ng-container>
		<ng-container *ngIf="showGroupedUpdates">
			<p-tabView>
				<p-tabPanel header="{{ 'FW_UPDATE_TAB_GATEWAY' | translate }}">
					<p *ngIf="gatewayFirmwareUpdates.length === 0"
						class="fw-update-empty flex align-items-center justify-content-center py-4 m-0 text-center">
						{{ 'FW_UPDATE_GATEWAY_NONE' | translate }}
					</p>
					<div *ngFor="let firmware of gatewayFirmwareUpdates"
						class="card flex align-items-center justify-content-between flex-wrap font-bold px-4 py-3 mb-2 gap-3 bg-yellow-200">
						<div class="flex flex-column gap-1">
							<div class="font-medium">{{ 'FROM_VERSION' | translate }}: {{ firmware.DeviceFWVersion }}
								&nbsp;→&nbsp; {{ 'TO_VERSION' | translate }}: {{ firmware.AvailableFWVersion }}</div>
						</div>
						<div class="flex align-items-center flex-wrap gap-2">
							<p-button *ngIf="!onExtendedMobile()" label="{{ 'UPDATE_FIRWARE' | translate }}"
								(click)="confirmFirmwareUpdate(firmware, 'FW_UPDATE_CONFIRM_GATEWAY')"
								[disabled]="isDeviceUnavailable() || onFirmwareUpdate()" icon="pi cm-update-firmware"
								[rounded]="false" [text]="true" severity="warning" styleClass="font-bold border-yellow-600">
							</p-button>
							<p-button *ngIf="onExtendedMobile()" pTooltip="{{ 'UPDATE_FIRWARE' | translate }}"
								tooltipPosition="bottom" icon="pi cm-update-firmware" size="large"
								(click)="confirmFirmwareUpdate(firmware, 'FW_UPDATE_CONFIRM_GATEWAY')"
								[disabled]="isDeviceUnavailable() || onFirmwareUpdate()"
								[rounded]="false" [text]="true" severity="warning">
							</p-button>
						</div>
					</div>
				</p-tabPanel>
				<p-tabPanel>
					<ng-template pTemplate="header">
						<span class="flex align-items-center gap-2">
							{{ 'FW_UPDATE_TAB_AUTOMATIONS' | translate }}
							<i *ngIf="hasAutomationFirmwareUpdates" class="pi cm-info text-primary"></i>
						</span>
					</ng-template>
					<div *ngFor="let row of automationFwRows"
						class="card flex align-items-center justify-content-between flex-wrap font-bold px-4 py-3 mb-2 gap-3"
						[ngClass]="row.update ? 'bg-yellow-200' : ''">
						<div class="flex flex-column gap-1">
							<div>{{ row.device.Name }}</div>
							<div *ngIf="row.update" class="font-medium">{{ 'FROM_VERSION' | translate }}: {{ row.update.DeviceFWVersion }}
								&nbsp;→&nbsp; {{ 'TO_VERSION' | translate }}: {{ row.update.AvailableFWVersion }}</div>
						</div>
						<p-button *ngIf="row.update && !onExtendedMobile()" label="{{ 'UPDATE_FIRWARE' | translate }}"
							(click)="confirmFirmwareUpdate(row.update, 'FW_UPDATE_CONFIRM_AUTOMATION')"
							[disabled]="isDeviceUnavailable() || onFirmwareUpdate()" icon="pi cm-update-firmware"
							[rounded]="false" [text]="true" severity="warning" styleClass="font-bold border-yellow-600">
						</p-button>
						<p-button *ngIf="row.update && onExtendedMobile()" pTooltip="{{ 'UPDATE_FIRWARE' | translate }}"
							tooltipPosition="bottom" icon="pi cm-update-firmware" size="large"
							(click)="confirmFirmwareUpdate(row.update, 'FW_UPDATE_CONFIRM_AUTOMATION')"
							[disabled]="isDeviceUnavailable() || onFirmwareUpdate()"
							[rounded]="false" [text]="true" severity="warning">
						</p-button>
					</div>
				</p-tabPanel>
			</p-tabView>
		</ng-container>
	</div>
</div>
